import { IApplicationState, IUserState } from '../../types/redux';

const defaultState: IUserState = {
  abGroup: 100,
  userId: null,
};

export function userReducer(state: IApplicationState['user'] = defaultState) {
  return state;
}
